import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=51399c04&scoped=true"
import script from "./AddEdit.vue?vue&type=script&lang=js"
export * from "./AddEdit.vue?vue&type=script&lang=js"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=51399c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51399c04",
  null
  
)

export default component.exports